// extracted by mini-css-extract-plugin
export var filterIncDec = "_4q-0";
export var leftBorder = "_4q-1";
export var rightBorder = "_4q-2";
export var stringInput = "_4q-3";